// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"746c34c9","455":"b6b88560","977":"2881c0ae"}[chunkId] + ".chunk.js";
};